import { differenceInCalendarDays, isValid, parseISO } from 'date-fns';

const providerLabels: Record<string, string> = {
  PROPERTY24: 'Property24',
  PRIVATE_PROPERTY: 'Private Property',
  KWHOMES: 'KWHomes',
};

export function providerLabel(provider: string): string {
  return providerLabels[provider] ?? provider;
}

export function daysOnMarket(listingDate: string | null, now = new Date()): number | null {
  if (!listingDate || !/^\d{4}-\d{2}-\d{2}$/.test(listingDate) || !isValid(now)) return null;
  const start = parseISO(listingDate);
  if (!isValid(start)) return null;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = (type: string) => parts.find((item) => item.type === type)?.value ?? '';
  const today = parseISO(`${part('year')}-${part('month')}-${part('day')}`);
  return Math.max(0, differenceInCalendarDays(today, start));
}

export function safeEnquiryCategory(type: string | null): string {
  switch ((type ?? '').trim().toLowerCase()) {
    case 'viewing':
    case 'viewing_request':
    case 'request_viewing':
    case 'appointment':
    case 'viewing request':
      return 'Viewing request';
    case 'price':
    case 'price_enquiry':
    case 'price_inquiry':
    case 'price enquiry':
      return 'Price enquiry';
    case 'property_information':
    case 'property_information_request':
    case 'property_info':
    case 'details_request':
    case 'property information request':
      return 'Property information request';
    case 'other':
      return 'Other';
    default:
      return 'General enquiry';
  }
}